import { render } from "./Comment.vue?vue&type=template&id=a5370c4a&scoped=true&ts=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=a5370c4a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5370c4a"]])

export default __exports__